'use client';

import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

import type { Component } from './types';

export const MobilePathRedirector: Component = ({
  modelId,
  slug,
  redirectPaths,
}) => {
  const { isDesktop } = useScreenDetect();
  const [isInitialized, setIsInitialized] = useState(false);
  const isDesktopMode = isDesktop();

  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (!isInitialized) {
      return;
    }

    if (isDesktopMode) {
      return;
    }

    const pathSegments = pathname.split('/');
    const lastSegment = pathSegments[pathSegments.length - 1];

    if (redirectPaths.includes(lastSegment)) {
      router.replace(`/info/${modelId}/${slug}`);
    }
  }, [pathname,
    modelId,
    slug,
    redirectPaths,
    router,
    isDesktopMode,
    isInitialized]);

  return null;
};
